import { graphql, useStaticQuery } from 'gatsby';
import * as React from 'react';
import InfoCard from '../../InfoCard';
import InlineSvg from '../../InlineSvg';
import CallToAction from '../../CallToAction-NEW';

export const ThankYouType = Object.freeze({
  GENERAL_ENQUIRY: 'generalEnquiry',
  NON_URGENT_MAINTENANCE: 'nonUrgentMaintenance',
  REGISTERED_ELECTRICAL_CONTRACTORS: 'registeredElectricalContractors',
});

const ThankYou = ({ emailData, wysiwyg = null, type = null }) => {
  const ref = React.useRef(null);

  React.useEffect(() => {
    ref.current && ref.current.scrollIntoView();
  }, []);

  // Fix me please! This is a workaround for the fact that `useStaticQuery` cannot
  // be used in class components, however the component for general enquiry form is
  // a class component, I tried wrapping a functional component around this but got
  // an error "The result of this StaticQuery could not be fetched." so it seems
  // like dynamically static queries are not possible in Gatsby. So once, the
  // general enquiry form is converted to a functional component, this can be
  // removed. And `wyiswyg` can be passed as a prop to this component, and type can be removed
  const thankYouWyiswyg = useStaticQuery(graphql`
    query ThankYouWysiwyg {
      wp {
        acfOptionsFormThankYouContents {
          formThankYouContents {
            generalEnquiry {
              dangerMessage
              emergencyInfo
              thankYou
            }
            nonUrgentMaintenance {
              dangerMessage
              emergencyInfo
              thankYou
            }
            registeredElectricalContractorEnquiry {
              thankYou
              callsToAction {
                ... on WpCall_to_action {
                  databaseId
                  title
                }
              }
            }
          }
        }
      }
    }
  `);

  if (!wysiwyg) {
    switch (type) {
      case ThankYouType.GENERAL_ENQUIRY:
        wysiwyg =
          thankYouWyiswyg?.wp?.acfOptionsFormThankYouContents
            ?.formThankYouContents?.generalEnquiry;
        break;
      case ThankYouType.NON_URGENT_MAINTENANCE:
        wysiwyg =
          thankYouWyiswyg?.wp?.acfOptionsFormThankYouContents
            ?.formThankYouContents?.nonUrgentMaintenance;
        break;
      case ThankYouType.REGISTERED_ELECTRICAL_CONTRACTORS:
        wysiwyg =
          thankYouWyiswyg?.wp?.acfOptionsFormThankYouContents
            ?.formThankYouContents?.registeredElectricalContractorEnquiry;
        break;
    }
  }

  return (
    <section ref={ref} className="thank-you__page">
      <div className="thank-you__container">
        {wysiwyg ? (
          <div className="thank-you__card-row">
            {wysiwyg.dangerMessage && (
              <InfoCard icon="alert-filled" backgroundColour="red-100">
                <div
                  dangerouslySetInnerHTML={{
                    __html: wysiwyg.dangerMessage,
                  }}
                />
              </InfoCard>
            )}
            {wysiwyg.emergencyInfo && (
              <InfoCard icon="phone-filled" backgroundColour="blue-3">
                <div className="contact__wrapper">
                  <div className="contact__row">
                    <div>
                      <p className="contact">
                        For Powercor Faults
                        <br />
                        <span className="contact contact--important">
                          13 24 12
                        </span>
                      </p>
                    </div>
                    <div>
                      <p className="contact">
                        For CitiPower Faults
                        <br />
                        <span className="contact contact--important">
                          13 12 80
                        </span>
                      </p>
                    </div>
                  </div>
                  <div
                    dangerouslySetInnerHTML={{
                      __html: wysiwyg.emergencyInfo,
                    }}
                  />
                </div>
              </InfoCard>
            )}
            {wysiwyg.callsToAction &&
              wysiwyg.callsToAction.map((callToAction) => (
                <div
                  key={callToAction.databaseId}
                  className="thank-you__call-to-action"
                >
                  <CallToAction
                    module={{
                      backgroundColour: 'citipower',
                      callToAction,
                    }}
                  />
                </div>
              ))}
          </div>
        ) : (
          <div className="success-message">
            Thanks for you enquiry. Here is a copy of your submission:
          </div>
        )}

        {emailData?.copy && (
          <div className="thank-you__submission">
            <div className="thank-you__message">
              <InlineSvg name="tick-filled" className="" />
              <p dangerouslySetInnerHTML={{ __html: wysiwyg.thankYou }} />
            </div>
            <p>
              <strong>
                <i>Submission Copy</i>
              </strong>
            </p>
            <div dangerouslySetInnerHTML={{ __html: emailData.copy }} />
          </div>
        )}
      </div>
    </section>
  );
};

export default ThankYou;
